<template>
  <div id="change-password">
    <h2>Change Your Password</h2>
    <form @submit.prevent="changePassword">
      <div v-if="apiError" class="error">
        Error: {{ apiErrorMessage }}<br />
      </div>
      <div v-if="isError" class="error">Error with form<br /></div>
      <label>
        Current Password<br />
        <input
          v-model.trim="passwords.old_password"
          type="text"
          placeholder="current"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'current'"
          required
        /><br />
      </label>
      <label>
        New Password<br />
        <input
          v-model.trim="passwords.new_password"
          type="text"
          placeholder="new"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'new'"
          required
        /><br />
      </label>
      <div v-if="isPasswordError" class="error">{{ errorPasswordMessage }}</div>
      <button class="button button-300" type="submit">Change Password</button>
    </form>
  </div>
</template>

<script>
import api from "@/api/index";
const apiServiceUser = new api.APIServiceUser();

export default {
  data() {
    return {
      passwords: {
        old_password: "",
        new_password: ""
      },
      isError: false,
      isPasswordError: false,
      errorPasswordMessage: "",
      apiError: false,
      apiErrorMessage: ""
    };
  },
  created() {
    this.isPasswordError = false;
    this.errorPasswordMessage = "";
    this.isError = false;
    this.apiError = false;
    this.apiErrorMessage = "";
  },
  methods: {
    changePassword: function() {
      this.isPasswordError = false;
      this.errorPasswordMessage = "";
      this.isError = false;
      this.apiError = false;
      this.apiErrorMessage = "";
      if (this.passwords.new_password.length < 8) {
        this.isError = true;
        this.isPasswordError = true;
        this.errorPasswordMessage =
          "Password length must be 8 characters or longer";
      }
      if (!this.isPasswordError) {
        // this.$store.dispatch('changePassword', this.passwords);
        apiServiceUser
          .changePassword(this.payload)
          .then(data => {
            this.$router.push("/console/account");
          })
          .catch(e => {
            this.apiError = true;
            this.apiErrorMessage = e.response.data.message;
          });
      }
    }
  }
};
</script>
<style>
#change-password {
  text-align: left;
  margin-left: 20px;
}
#edit-password div {
  font-size: 1.2em;
  padding: 15px;
}
</style>
